import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "bg-white dark:bg-gray-900" }
const _hoisted_2 = { class: "container min-h-screen px-6 py-12 mx-auto lg:flex lg:items-center lg:gap-12" }
const _hoisted_3 = { class: "wf-ull text-left lg:w-1/2" }
const _hoisted_4 = /*#__PURE__*/_createElementVNode("p", { class: "text-sm font-medium text-purple-500 dark:text-purple-400" }, " 404 error ", -1)
const _hoisted_5 = /*#__PURE__*/_createElementVNode("h1", { class: "mt-3 text-2xl font-semibold text-gray-800 dark:text-white md:text-3xl" }, " Page not found ", -1)
const _hoisted_6 = /*#__PURE__*/_createElementVNode("p", { class: "mt-4 text-gray-500 dark:text-gray-400" }, " Sorry, the page you are looking for doesn't exist.Here are some helpful links: ", -1)
const _hoisted_7 = /*#__PURE__*/_createElementVNode("button", { class: "w-1/2 px-5 py-2 mt-4 text-sm tracking-wide text-white transition-colors duration-200 bg-purple-500 rounded-lg shrink-0 sm:w-auto hover:bg-purple-600 dark:hover:bg-purple-500 dark:bg-purple-600" }, " Take me home ", -1)
const _hoisted_8 = { class: "relative w-full mt-12 lg:w-1/2 lg:mt-0" }
const _hoisted_9 = ["src"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("section", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _hoisted_4,
        _hoisted_5,
        _hoisted_6,
        _createVNode(_component_router_link, { to: { name: 'HomePage' } }, {
          default: _withCtx(() => [
            _hoisted_7
          ]),
          _: 1
        })
      ]),
      _createElementVNode("div", _hoisted_8, [
        _createElementVNode("img", {
          class: "w-full max-w-lg lg:mx-auto",
          src: require('public/404-illustrations.svg'),
          alt: "Page Not Found",
          title: "Page Not Found"
        }, null, 8, _hoisted_9)
      ])
    ])
  ]))
}